import React, { useEffect, useState } from "react";
import { useAuth } from "./auth";
import { addRoom, getRoomDetails, getRoomDetailsByPg } from "./apiService";
import { useNavigate } from "react-router-dom";

const NewRoom = () => {
  const [roomname, setRoomname] = useState("");
  const [beds, setBeds] = useState("");
  const [errors, setErrors] = useState({});
  const [roomdetails, setRoomdetails] = useState([]);

  const { pgid, rcount } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    getRoomDetailsByPg(pgid)
      .then((res) => {
        setRoomdetails(res);
      })
      .catch((e) => console.log(e));
  }, []);

  const handleRoomSubmit = () => {
    let errors = {};
    if (!roomname) errors.roomname = "Room name is required";
    if (!beds) errors.beds = "Enter valid number here";

    const fRooms = roomdetails.filter((room) => {
      return room.pgname === pgid;
    });

    roomdetails.forEach((room) => {
      if (room.roomname === roomname) {
        errors.roomname = "Room name exists in current PG";
      }
      return errors;
    });

    setErrors(errors);

    // console.log(Object.keys(fRooms).length);

    if (Object.keys(errors).length === 0) {
      if (Object.keys(fRooms).length < rcount) {
        const room = {
          roomname: roomname,
          beds: beds,
          pgname: pgid,
        };

        addRoom(room);

        setRoomname("");
        setBeds("");
        navigate("/Dashboard/MyPGDetails");
      } else {
        alert(
          "The No of Rooms in the current PG has reached to Maximum Limit. Try to increase the rooms in the current PG or Create New PG"
        );
      }
    }
  };
  return (
    <div className="container">
      <div className="header">NewRoom</div>
      <div className="label">
        Room Name:
        <input
          type="text"
          className="inputbox"
          name="pgname"
          value={roomname}
          onChange={(e) => setRoomname(e.target.value)}
        />
        {errors.roomname ? (
          <div className="errortext">{errors.roomname}</div>
        ) : null}
      </div>

      <div className="label">
        No.of Beds:
        <input
          type="text"
          className="inputbox"
          name="rooms"
          value={beds}
          onChange={(e) => setBeds(e.target.value)}
        />
        {errors.beds ? <div className="errortext">{errors.beds}</div> : null}
      </div>
      <input
        type="submit"
        className="btn-cls"
        value="Submit"
        onClick={handleRoomSubmit}
      />
    </div>
  );
};

export default NewRoom;
